import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

var toRadians = function toRadians(angle) {
  return angle * (Math.PI / 180);
};

var getMouseAngle = function getMouseAngle(centerX, centerY, x, y) {
  var mainVector = {
    x: 0,
    y: -1
  };
  var mouseVector = {
    x: x - centerX,
    y: y - centerY
  };
  var crossProduct = mainVector.x * mouseVector.y - mouseVector.x * mainVector.y;
  var dotProduct = mainVector.x * mouseVector.x + mainVector.y * mouseVector.y;
  var angle = Math.atan2(crossProduct, dotProduct) * 180 / Math.PI;
  return angle > 0 ? angle : 360 + angle;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var _templateObject = taggedTemplateLiteral(['\n  position: absolute;\n  color: ', ';\n  border-radius: 50%;\n  text-align: center;\n  vertical-align: middle;\n  background-color: ', ';\n  cursor: pointer;\n  user-select: none;\n'], ['\n  position: absolute;\n  color: ', ';\n  border-radius: 50%;\n  text-align: center;\n  vertical-align: middle;\n  background-color: ', ';\n  cursor: pointer;\n  user-select: none;\n']);

var getMinutePercentageSize = function getMinutePercentageSize(diameter) {
  console.log(diameter);
  if (diameter < 400) {
    return 0.1;
  }
  if (diameter < 320) {
    return 0.12;
  }
  return 0.09;
};

var getMinutes = function getMinutes(start, step, limit) {
  var inner = function inner(minutes) {
    var last = minutes[minutes.length - 1];
    var next = last + step;
    if (next > limit) return minutes;

    return inner([].concat(toConsumableArray(minutes), [next]));
  };
  return inner([start]);
};

var Minutes = styled.p(_templateObject, function (props) {
  return props.selected ? props.theme.selectTextColor : props.theme.selectColor;
}, function (props) {
  return props.selected ? props.theme.selectColor : 'transparent';
});

var Minutes$1 = (function (_ref) {
  var diameter = _ref.diameter,
      duration = _ref.duration,
      _onClick = _ref.onClick;

  var center = diameter / 2;
  var radius = center * 0.8;
  var minutesNumbers = getMinutes(5, 5, 60);
  var size = diameter * getMinutePercentageSize(diameter);

  var moveDistance = size / 2;
  var minutes = minutesNumbers.map(function (minute) {
    var angle = toRadians(minute * 6);
    var left = center + radius * Math.sin(angle) - moveDistance;
    var top = center - radius * Math.cos(angle) - moveDistance;
    var style = {
      top: top,
      left: left,
      fontSize: size / 2,
      width: size,
      height: size,
      lineHeight: size + 'px'
    };
    var clickableProps = _onClick ? {
      onClick: function onClick() {
        return _onClick(minute);
      }
    } : {};
    return React.createElement(
      Minutes,
      _extends({}, clickableProps, { style: style, key: minute, selected: minute === duration }),
      minute
    );
  });

  return minutes;
});

var _templateObject$1 = taggedTemplateLiteral(['\n  position: absolute;\n  stroke-width: 1;\n  stroke: ', ';\n'], ['\n  position: absolute;\n  stroke-width: 1;\n  stroke: ', ';\n']);

var Line = styled.line(_templateObject$1, function (props) {
  return props.theme.selectColor;
});

var Line$1 = (function (_ref) {
  var duration = _ref.duration,
      diameter = _ref.diameter;

  var angle = toRadians(duration * 6);
  var radius = diameter / 2;
  var lineProps = {
    x1: radius + radius * 0.8 * Math.sin(angle) * 0.36,
    y1: radius - radius * 0.8 * Math.cos(angle) * 0.36,
    x2: radius + radius * 0.8 * Math.sin(angle) * 0.9,
    y2: radius - radius * 0.8 * Math.cos(angle) * 0.9
  };

  return React.createElement(
    'svg',
    { height: diameter, width: diameter, style: { position: 'absolute' } },
    React.createElement(Line, lineProps)
  );
});

var StartIcon = (function () {
  return React.createElement(
    "svg",
    { viewBox: "0 0 19.41 19.41" },
    React.createElement(
      "g",
      null,
      React.createElement("path", {
        fill: "#fff",
        d: "M5.9,12.33a.66.66,0,0,0-1,0C2.91,14.69-.28,19,.37,19.63s4.94-2.54,7.27-4.58a.66.66,0,0,0,0-1Z",
        transform: "translate(-0.29 -0.3)"
      }),
      React.createElement("path", {
        fill: "#fff",
        d: "M13.54,16l.66-3.49a13.25,13.25,0,0,0,1.69-1.42A13,13,0,0,0,19.66.93a.64.64,0,0,0-.59-.59A13,13,0,0,0,8.9,4.11,13.25,13.25,0,0,0,7.48,5.8L4,6.46a.7.7,0,0,0-.34.18L1.36,8.93A.65.65,0,0,0,1.88,10L5.61,9.7c-.07.23-.13.47-.19.7A.66.66,0,0,0,5.6,11L9,14.4a.66.66,0,0,0,.61.18l.7-.19L10,18.12a.65.65,0,0,0,1.11.52l2.29-2.29A.7.7,0,0,0,13.54,16ZM12,8a2,2,0,1,1,2.77,0A2,2,0,0,1,12,8Z",
        transform: "translate(-0.29 -0.3)"
      })
    )
  );
});

var _templateObject$2 = taggedTemplateLiteral(['\n  position: absolute;\n  border-radius: 50%;\n  background-color: ', ';\n  border-width: 0;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);\n  &:hover {\n    transform: scale(1.2);\n    cursor: pointer;\n    fill: #ffffff;\n    color: #ffffff;\n  }\n'], ['\n  position: absolute;\n  border-radius: 50%;\n  background-color: ', ';\n  border-width: 0;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);\n  &:hover {\n    transform: scale(1.2);\n    cursor: pointer;\n    fill: #ffffff;\n    color: #ffffff;\n  }\n']);

var StartButton = styled.button(_templateObject$2, function (props) {
  return props.theme.actionColor;
});

var noPropagation = function noPropagation() {
  var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return null;
  };
  return function (e) {
    e.stopPropagation();
    func();
  };
};

var Start = (function (_ref) {
  var onClick = _ref.onClick,
      diameter = _ref.diameter,
      padding = _ref.padding;
  return React.createElement(
    StartButton,
    {
      onClick: noPropagation(onClick),
      onMouseDown: noPropagation(),
      onTouchStart: noPropagation(),
      style: { width: diameter, height: diameter, padding: padding }
    },
    React.createElement(StartIcon, null)
  );
});

var _templateObject$3 = taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n'], ['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n']);

var Circle = styled.div(_templateObject$3, function (props) {
  return props.theme.circleColor;
});

var defaultTheme = {
  actionColor: 'rgba(231, 76, 60,.9)',
  selectColor: '#ecf0f1',
  selectTextColor: '#34495e',
  circleColor: 'rgba(255, 255, 255, 0.15)'
};

var _templateObject$4 = taggedTemplateLiteral(['\n  margin: auto;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  margin: auto;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']);

var Container = styled.div(_templateObject$4);

var TimePicker = function (_React$Component) {
  inherits(TimePicker, _React$Component);

  function TimePicker(props) {
    classCallCheck(this, TimePicker);

    var _this = possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

    _this.onMouseDown = function (e) {
      _this.updatePosition(e);
      _this.setState({ touching: true });
    };

    _this.onMouseMove = function (e) {
      if (_this.state.touching) {
        _this.updatePosition(e);
      }
    };

    _this.onMouseUp = function () {
      _this.setState({ touching: false });
    };

    _this.updatePosition = function (e) {
      if (!e.pageX && !e.changedTouches) return;

      var rect = _this.view.getBoundingClientRect();

      var _ref = e.pageX ? e : e.changedTouches[0],
          pageX = _ref.pageX,
          pageY = _ref.pageY;

      var x = pageX - rect.left;
      var y = pageY - rect.top;

      var diameter = _this.state.diameter;

      var center = diameter / 2;
      var mouseAngle = getMouseAngle(center, center, x, y);
      var onTop = mouseAngle < 15 || mouseAngle > 345;
      var minutes = onTop ? 60 : Math.round(mouseAngle / 30) * 5;
      var _this$props = _this.props,
          duration = _this$props.duration,
          onDurationChange = _this$props.onDurationChange;

      if (minutes !== duration) {
        onDurationChange(minutes);
      }
    };

    _this.onResize = function () {
      if (_this.wrapper) {
        var _this$wrapper$getBoun = _this.wrapper.getBoundingClientRect(),
            width = _this$wrapper$getBoun.width,
            height = _this$wrapper$getBoun.height;

        var diameter = Math.min(width, height);
        _this.setState({ width: width, height: height, diameter: diameter });
      }
    };

    _this.state = {
      width: 0,
      height: 0,
      touching: false
    };
    return _this;
  }

  createClass(TimePicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Wrapper = _props.wrapper,
          theme = _props.theme,
          noDrag = _props.noDrag,
          onDurationChange = _props.onDurationChange;
      var _state = this.state,
          width = _state.width,
          height = _state.height,
          diameter = _state.diameter;

      var renderContent = function renderContent() {
        var startDiameter = diameter * (width > height ? 0.16 : 0.2);
        var startPadding = startDiameter * 0.3;
        var _props2 = _this2.props,
            duration = _props2.duration,
            onStart = _props2.onStart;


        return React.createElement(
          React.Fragment,
          null,
          React.createElement(
            Circle,
            null,
            !noDrag && React.createElement(Line$1, { diameter: diameter, duration: duration }),
            React.createElement(Minutes$1, { onClick: noDrag ? onDurationChange : undefined, diameter: diameter, duration: duration })
          ),
          React.createElement(Start, {
            onClick: onStart,
            diameter: startDiameter,
            padding: startPadding
          })
        );
      };
      var dragParams = noDrag ? {} : {
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onMouseDown,
        onMouseMove: this.onMouseMove,
        onTouchMove: this.onMouseMove,
        onMouseUp: this.onMouseUp,
        onTouchEnd: this.onMouseUp
      };
      return React.createElement(
        ThemeProvider,
        { theme: _extends({}, defaultTheme, theme) },
        React.createElement(
          Wrapper,
          { ref: function ref(el) {
              return _this2.wrapper = el;
            } },
          React.createElement(
            Container,
            _extends({
              ref: function ref(el) {
                return _this2.view = el;
              },
              style: { width: diameter, height: diameter }
            }, dragParams),
            this.view && renderContent()
          )
        )
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }]);
  return TimePicker;
}(React.Component);

export default TimePicker;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 35
// module chunks = 0